import {
  SET_CONTENT,
  SHOW_DIALOG,
  SET_RESOLVE,
  RESET_STATE
} from "./constants";
import { initialState } from "./index";

export default {
  [SET_CONTENT](
    state,
    {
      title,
      okText,
      cancelText,
      onOk,
      onCancel,
      maxWidth,
      icon,
      content,
      autofocus,
      layer
    }
  ) {
    state.dialogTitle = title;
    state.okText = okText;
    state.cancelText = cancelText;
    state.onOk = onOk;
    state.onCancel = onCancel;
    state.maxWidth = maxWidth;
    state.icon = icon;
    state.content = content;
    state.autofocus = autofocus;
    state.layer = layer;
  },
  [SHOW_DIALOG](state, newState) {
    state.showDialog = newState;
  },
  [SET_RESOLVE](state, newResolve) {
    state.resolve = newResolve;
  },
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  }
};
